<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(recognition_id ? 'Edit' : 'Add') + ' Employee Recognition :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/recognition-list`">
                            <i class="fa fa-trophy"></i> Recognitions
                        </router-link>
                    </li>
                    <li v-if="recognition_id" class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/recognition/view/${recognition_id}`">
                            {{ recognition.employee_first_name }} {{ recognition.employee_last_name }} for {{ recognition.recognition_name }} on {{ recognition.recognition_date | moment("MM/DD/YYYY") }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ recognition_id ? 'Edit' : 'Add' }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-header">Recognition Details</div>
                        <div class="card-body">
                            <div v-if="this.$root.hasPermission('recognitions.manage')" class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.creator_id}">
                                    For User: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <user-select :selectedValues="userSelectValues" @vuselected="onUserSelectUpdate" :hasError="errors.creator_id ? true : false"></user-select>
                                    <span v-if="errors.creator_id" class="text-danger">
                                        <span v-for="error in errors.creator_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.employee_id}">
                                    Employee: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <b-input v-if="request_employee_id && !recognition_id" readonly type="text" :value="recognition.employee_first_name + ' ' + recognition.employee_last_name"></b-input>

                                    <employee-select v-else :selectedValues="(recognition.employee_id ? {FirstName: recognition.employee_first_name, LastName: recognition.employee_last_name} : {})" ref="employeeSelector" @vselected="onEmployeeSelect" :hasError="errors.employee_id ? true : false"></employee-select>

                                    <span v-if="errors.employee_id" class="text-danger">
                                        <span v-for="error in errors.employee_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.recognition_id}">
                                    Recognition Type: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <b-select :class="{ 'is-invalid': errors.recognition_id }" v-model="recognition.recognition_id">
                                        <option :value="undefined">
                                            -- Select a Recognition --
                                        </option>
                                        <option v-for="recognition_option in recognition_list" :value="recognition_option.recognition_id">
                                            {{ recognition_option.recognition_name }}
                                        </option>
                                    </b-select>

                                    <span v-if="errors.recognition_id" class="text-danger">
                                        <span v-for="error in errors.recognition_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.supervisor_id}">Superintendent:</label>
                                <div class="col-sm-8">
                                    <employee-select :selectedValues="recognition.supervisor_id ? {FirstName: recognition.super_first_name, LastName: recognition.super_last_name} : {}" ref="supervisorSelector" @vselected="onSupervisorSelect" :hasError="errors.supervisor_id ? true : false"></employee-select>

                                    <span v-if="errors.supervisor_id" class="text-danger">
                                        <span v-for="error in errors.supervisor_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.foreman_id}">Foreman:</label>
                                <div class="col-sm-8">
                                    <employee-select :selectedValues="recognition.foreman_id ? {FirstName: recognition.foreman_first_name, LastName: recognition.foreman_last_name} : {}" ref="foremanSelector" @vselected="onForemanSelect" :hasError="errors.foreman_id ? true : false"></employee-select>

                                    <span v-if="errors.foreman_id" class="text-danger">
                                        <span v-for="error in errors.foreman_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.jobsite_id}">Jobsite:</label>
                                <div class="col-sm-8">
                                    <jobsite-select :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.recognition_date}">
                                    Date of Recognition: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <date-picker v-model="recognition.recognition_date" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors.recognition_date }" placeholder="Recognition Date"></date-picker>

                                    <span v-if="errors.recognition_date" class="text-danger">
                                        <span v-for="error in errors.recognition_date">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.explanation}">Explanation:</label>
                                <div class="col-sm-8">
                                    <b-textarea rows="2" v-model="recognition.explanation" :class="{ 'is-invalid': errors.explanation }" placeholder="Explanation"></b-textarea>

                                    <span v-if="errors.explanation" class="text-danger">
                                        <span v-for="error in errors.explanation">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="offset-md-3 offset-sm-4 col-sm-8">
                                    <b-form-file plain v-model="explanation_file" :class="{'is-invalid': errors.files}"/>

                                    <span v-if="errors.files" class="text-danger">
                                        <span v-for="error in errors.files">{{ error }}</span>
                                    </span>

                                    <template v-if="recognition.explanation_file_id">
                                        <hr/>
                                        <div class="mb-2">
                                            <div>{{ recognition.explanation_file.file_name }}</div>
                                            <span v-if="!recognition.explanation_file.download_only">
                                                <a :href="`/files/view/${recognition.explanation_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                            </span>
                                            <a :href="`/files/download/${recognition.explanation_file.file_id}`" target="_blank">Download</a>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.status}">
                                    Status: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <b-select :class="{ 'is-invalid': errors.status }" v-model="recognition.status">
                                        <option :value="undefined">
                                            -- Select a Status --
                                        </option>
                                        <option value="Open">
                                            Open
                                        </option>
                                        <option value="Closed">
                                            Closed
                                        </option>
                                    </b-select>

                                    <span v-if="errors.status" class="text-danger">
                                        <span v-for="error in errors.status">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.general_comments}">General Comments:</label>
                                <div class="col-sm-8">
                                    <b-textarea rows="2" v-model="recognition.general_comments" :class="{ 'is-invalid': errors.general_comments }" placeholder="General Comments"></b-textarea>

                                    <span v-if="errors.general_comments" class="text-danger">
                                        <span v-for="error in errors.general_comments">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" @click="saveRecognition(this)" :disabled="saving">
                {{ recognition_id ? 'Update' : 'Create' }} Recognition
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                request_employee_id: this.$route.query.employee_id,
                employee: null,
                recognition_id: this.$route.params.id,
                recognition: {},
                recognition_list: {},
                errors: {},
                explanation_file: null,
            }
        },

        computed: {
            JobsiteValues(){
                //Check for an existing recognition where a jobsite was not selected
                if(this.recognition.employee_recognition_id && !this.recognition.jobsite_id)
                {
                    //Send NULL
                    return null;
                }

                //check for null
                if(!this.recognition.jobsite_id || this.recognition.jobsite_id == null)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.recognition.jobsite_id = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.recognition.jobsite_id, JobsiteNumber: this.recognition.JobsiteNumber, JobsiteName: this.recognition.JobsiteName};
            },

            userSelectValues(){
                //Check for null
                if(!this.recognition.creator_id || this.recognition.creator_id == null)
                {
                    let user = this.$store.state.user;
                    this.recognition.creator_id = user.user_id;
                    return { UserId: user.user_id, FirstName: user.first_name, LastName: user.last_name};
                }

                //Send it
                return { UserId: this.recognition.creator_id, FirstName: this.recognition.creator_first_name, LastName: this.recognition.creator_last_name};
            },
        },

        methods: {
            onEmployeeSelect(employee){
                this.recognition.employee_id = employee ? employee.EmployeeId : null;
            },

            onSupervisorSelect(employee){
                this.recognition.supervisor_id = employee ? employee.EmployeeId : null;
            },

            onForemanSelect(employee){
                this.recognition.foreman_id = employee ? employee.EmployeeId : null;
            },

            onJobSiteSelectUpdate (jobsite) {
                //Set the value
                this.recognition.jobsite_id = jobsite ? jobsite.JobsiteId : null;
            },

            onUserSelectUpdate (user){
                //Set the value
                this.recognition.creator_id = user ? user.UserId : null;
            },

            getRecognition: function() {
                let params = {};
                if (this.request_employee_id)
                {
                    params.employee_id = this.request_employee_id;
                }
                //Get the data
                this.$http
                    .get('employees/recognition/edit'+(this.recognition_id ? `/${this.recognition_id}` : ''), params)
                    .then(response => {
                        //Set all the data
                        this.employee = response.data.employee;
                        this.recognition_list = response.data.recognition_list;
                        this.recognition = response.data.recognition || this.recognition;

                        if (this.employee)
                        {
                            this.recognition.employee_id = this.employee.EmployeeId;
                        }

                        if (this.recognition && this.recognition.recognition_date)
                        {
                            this.recognition.recognition_date = moment(this.recognition.recognition_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
                        }

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveRecognition: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithFiles('employees/recognition/edit' + (this.recognition_id ? `/${this.recognition_id}` : ''),
                                this.recognition, (this.explanation_file ? [this.explanation_file] : []))
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Recognition Added');

                    //Return to main list?
                    if (this.employee_id)
                    {
                        this.$router.push('/employees/view/' + this.employee_id);
                    }
                    else
                    {
                        this.$router.push(`/employees/recognition/view/${response.data.employee_recognition_id}`);
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the Clients
            this.getRecognition();
        }
    }
</script>
